import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonButton ,IonIcon, IonItem, IonText } from '@ionic/react';
import { useParams } from 'react-router-dom';
import ListItems from '../components/ListItems';
import InnerMenu from '../components/InnerMenu';
import React, {useEffect, useState, useContext } from 'react';
import { Filesystem, Directory, Encoding, FilesystemDirectory } from '@capacitor/filesystem'; // currently not used
import { Browser } from '@capacitor/browser';
import PageEventHandler from "../components/PageEventHandler"
import './Batimetric.css';
import { LanguageContext } from '../contexts/LanguageContext';
import { batimetricTranslations } from '../translations/batimetric';
import NotificationRedirect from '../components/NotificationRedirect';


const Batimetric: React.FC = () => {
  const { language } = useContext(LanguageContext);
  const t = batimetricTranslations[language];

  const pageName = "Bollettini e Avvisi ai Naviganti (NtS)";
  const pageUrl = "https://www.agenziapo.it/content/bollettino-giornaliero";
  const pageAlertUrl = "https://www.agenziapo.it/elenco_avvisi_navigazione";
  const pageWaterMonitorUrl = "https://www.agenziapo.it/content/monitoraggio-idrografico-0";
  const pageForecastBulletinUrl = "https://www.agenziapo.it/content/smart-bulletin";
  // es report full url https://www.agenziapo.it/sites/default/files/bollettinipdf/Bollettino2022-04-27.pdf
  const reportBaseUrl = "https://www.agenziapo.it/sites/default/files/bollettinipdf/Bollettino";
  const [reportDateBit, setReportDateBit] = useState("");


  const showPdf = async () => {
    await Browser.open({ url: 'https://www.agenziapo.it/sites/default/files/dwd/attivita/navigazione_interna/segnaletica/regolamento_segnaletica.pdf'});
    console.log('Doc aperto in browser');
  };


  // call function to retrieve the device UUID
  useEffect(() => {
    const d = new Date();
    // before 1pm set the date to yesterday date, after 1pm set the date to today date
    const isBefore1pm = d.getHours() < 13;
    const dateToSet: Date = isBefore1pm ? new Date(d.setDate(d.getDate() - 1)) : d;
    const month = dateToSet.getMonth() + 1;
    const stringMonth = month < 10 ? "0"+month : ""+month;
    const stringDay = dateToSet.getDate() < 10 ? "0"+dateToSet.getDate() : ""+dateToSet.getDate();
    setReportDateBit(`${dateToSet.getFullYear()}-${stringMonth}-${stringDay}`);
  }, []);



  return (
    <IonPage>
      <IonHeader>
        <InnerMenu name={t.pageTitle} />
      </IonHeader>
      <IonContent fullscreen>
        <IonItem lines="none">
          <h1 className="mainTit" slot="start">{t.pageTitle}</h1>
        </IonItem>
        <div className="ion-padding ion-text-justify">
          {t.description}
        </div>
        <IonButton routerLink="/navigation-warnings" expand="block" fill="solid" className="ion-padding ruleBtn  ion-text-wrap">
          {t.appNoticesButton}
        </IonButton>
        <IonButton target="_blank" rel="noreferrer" href={`${reportBaseUrl}${reportDateBit}.pdf`} expand="block" fill="solid" className="ion-padding ruleBtn  ion-text-wrap">
          {t.downloadButton}
        </IonButton>
        <IonButton target="_blank" rel="noreferrer" href={pageWaterMonitorUrl} expand="block" fill="solid" className="ion-padding ruleBtn  ion-text-wrap">
          {t.monitoringButton}
        </IonButton>
        <IonButton target="_blank" rel="noreferrer" href={pageUrl} expand="block" fill="solid" className="ion-padding ruleBtn  ion-text-wrap">
          {t.checkBulletinButton}
        </IonButton>
        <IonButton target="_blank" rel="noreferrer" href={pageForecastBulletinUrl} expand="block" fill="solid" className="ion-padding ruleBtn  ion-text-wrap">
          {t.forecastBulletinButton}
        </IonButton>
        <IonButton target="_blank" rel="noreferrer" href={pageAlertUrl} expand="block" fill="solid" className="ion-padding ruleBtn  ion-text-wrap">
          {t.noticesButton}
        </IonButton>
      </IonContent>
      <PageEventHandler pageIndex={7} dockIndex={0}/>
      <NotificationRedirect /> {/* redirect to the page specified in the local storage */}
    </IonPage>
  );
};

export default Batimetric;
